import React from 'react';

const PivotSettings = ({ displayOptions, setDisplayOptions, excludeUnknown, setExcludeUnknown }) => {
  return (
    <div className="settings-tab">
      {/* Toggle for Exclude Unknown */}
      <div className="toggle-container">
        <div
          className={`toggle-switch ${excludeUnknown ? "active" : ""}`}
          onClick={() => setExcludeUnknown(!excludeUnknown)}
        >
          <div className="toggle-thumb" />
        </div>
        <label>Exclude &laquo; Unknown &raquo; entries</label>
      </div>

      <div className="settings-row">
        {/* Percentage Toggle */}
        <div className="toggle-container">
          <div
            className={`toggle-switch ${displayOptions.percentage ? "active" : ""}`}
            onClick={() =>
              setDisplayOptions((prev) => ({
                ...prev,
                percentage: !prev.percentage,
              }))
            }
          >
            <div className="toggle-thumb" />
          </div>
          <label>Apply Percentage Calculation :</label>
        </div>

        <select
          value={displayOptions.percentageType}
          onChange={(e) =>
            setDisplayOptions((prev) => ({
              ...prev,
              percentageType: e.target.value,
            }))
          }
          disabled={!displayOptions.percentage}
          className={!displayOptions.percentage ? "disabled" : ""}
        >
          <option value="global">Global</option>
          <option value="row-wise">Row-wise</option>
          <option value="column-wise">Column-wise</option>
        </select>

        {/* Calculation Type Dropdown */}
        <label>
          Apply Additional Calculation :
          <select
            value={displayOptions.calculationType}
            onChange={(e) =>
              setDisplayOptions((prev) => ({
                ...prev,
                calculationType: e.target.value,
              }))
            }
          >
            <option value="none">None</option>
            <option value="zscore">Z-score</option>
            <option value="rank">Ranking</option>
          </select>
        </label>

        {/* Z-Score Type Dropdown */}
        {displayOptions.calculationType === "zscore" && (
          <label>
            Z-Score Type :
            <select
              value={displayOptions.zScoreType}
              onChange={(e) =>
                setDisplayOptions((prev) => ({
                  ...prev,
                  zScoreType: e.target.value,
                }))
              }
            >
              <option value="global">Global</option>
              <option value="row-wise">Row-wise</option>
              <option value="column-wise">Column-wise</option>
            </select>
          </label>
        )}

        {/* Rank Type Dropdown */}
        {displayOptions.calculationType === "rank" && (
          <label>
            Rank Type :
            <select
              value={displayOptions.rankType}
              onChange={(e) =>
                setDisplayOptions((prev) => ({
                  ...prev,
                  rankType: e.target.value,
                }))
              }
            >
              <option value="global">Global</option>
              <option value="row-wise">Row-wise</option>
              <option value="column-wise">Column-wise</option>
            </select>
          </label>
        )}
      </div>
    </div>
  );
}

export default PivotSettings;
